import React from "react";
import { Moon, Sun } from "lucide-react";

import { useTheme } from "../../theme/ThemeProvider";

/**
 * Theme switch. Icon-only, sized and styled to match the session-chimes bell beside
 * it in the nav (see components/MarketChimes.tsx) so the two read as a pair rather
 * than as one button and one label.
 *
 * The icon shows the theme you would switch TO, not the one you are in - a sun means
 * "go light". With no text left to carry that meaning, the accessible name and the
 * tooltip have to say it explicitly, which is why they are phrased as the action
 * rather than the old generic "Toggle theme".
 */
const ThemeToggle: React.FC = () => {
  const { theme, toggleTheme } = useTheme();
  const label = theme === "dark" ? "Switch to light theme" : "Switch to dark theme";

  return (
    <button
      type="button"
      onClick={toggleTheme}
      aria-label={label}
      title={label}
      className="rounded-md px-3 py-2 text-sm font-medium transition-colors"
      style={{
        backgroundColor: "var(--button-bg)",
        color: "var(--nav-text)",
        border: "1px solid rgba(255, 255, 255, 0.55)",
        display: "inline-flex",
        alignItems: "center",
        gap: 6,
      }}
      onMouseEnter={(e) => {
        e.currentTarget.style.backgroundColor = "var(--button-bg-hover)";
      }}
      onMouseLeave={(e) => {
        e.currentTarget.style.backgroundColor = "var(--button-bg)";
      }}
    >
      {theme === "dark" ? <Sun size={16} /> : <Moon size={16} />}
    </button>
  );
};

export default ThemeToggle;
